import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class SidebarService {
  // private activeULSubject = new BehaviorSubject<string | null>(null);
  // activeUL$ = this.activeULSubject.asObservable();
  // setActiveUL(ul: string | null): void {
  //   this.activeULSubject.next(ul);
  // }
  // getActiveUL(): string | null {
  //   return this.activeULSubject.getValue();
  // }
}
